import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from '@vinnova/auth';
import { ChatbotService } from '@vinnova/chatbot';
import { EtjansterSites } from '@vinnova/e-tjanster';
import { Observable, of, switchMap, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { EnvironmentInfoQuery } from '../core/queries/environment-info.query';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent implements OnInit {
  hasError = false;
  environmentInfoText$: Observable<string>;
  isProduction: boolean;
  hasValidAccount: boolean;

  EtjansterSites = EtjansterSites;
  showChatbot = false;

  constructor(
    private authService: AuthService,
    private environmentInfoQuery: EnvironmentInfoQuery,
    private chatbotService: ChatbotService,
  ) {}

  ngOnInit() {
    this.environmentInfoText$ = this.authService.hasValidAccount().pipe(
      take(1),
      switchMap((hasValidAccount) =>
        hasValidAccount
          ? this.environmentInfoQuery.getEnvironmentInfoText()
          : of(''),
      ),
    );
    this.isProduction = environment.production;
    this.authService
      .hasValidAccountAndActiveCookie()
      .pipe(take(1))
      .subscribe((hasValidAccount) => {
        this.hasValidAccount = hasValidAccount;
      });

    this.chatbotService.isAvailable$
      .pipe(untilDestroyed(this))
      .subscribe((isAvailable) => {
        this.showChatbot = isAvailable;
      });
  }
}
